import React from "react";
import BackButton from "canvas-core-react/lib/BackButton";
import ContinueButton from "canvas-core-react/lib/ContinueButton";
import "./styles.scss";
import PrimaryButton from "canvas-core-react/lib/PrimaryButton";

const BackContinue = ({
	handleBack,
	handleContinue,
	continueDisabled,
	withContinue = true,
	withBack = true,
	backId = "",
	backClassName = "",
	continueId = "",
	continueClassName = "",
}) => {
	return (
		<div className="back-continue_container">
			{withBack &&
				<BackButton id={backId} className={backClassName} onClick={handleBack}>
					Volver
				</BackButton>
			}
			{withContinue &&
				<PrimaryButton
					id={continueId}
					className={continueClassName}
					onClick={() => handleContinue(true)}
					disabled={continueDisabled}
				>
					Aceptar y continuar
				</PrimaryButton>
			}
		</div>
	);
};


export default BackContinue;
